<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

import { useDisciplineStore } from '../model/store'
import { useLessonEditStore } from '../model/lessons/edit/store'
import DisciplinePageLoader from './DisciplinePageLoader.vue'
import LessonEditSingle from './lessons/LessonEditSingle.vue'
import LessonInfo from './lessons/LessonInfo.vue'

defineOptions({
  name: 'LessonDetailsPage',
})

const disciplineStore = useDisciplineStore()
const lessonEditStore = useLessonEditStore()
</script>

<template>
  <DisciplinePageLoader :loading="lessonEditStore.isLoading" />
  <template v-if="lessonEditStore.getLesson && disciplineStore.getDiscipline">
    <LessonEditSingle />
    <LessonInfo />
  </template>
  <AppText
    v-else-if="!lessonEditStore.isLoading && !lessonEditStore.getLesson"
    name="body1"
    color="slate-500"
  >
    The lesson is not found in this discipline.
  </AppText>
</template>
